module.exports = __webpack_public_path__ + "static/media/macbook_ratatool_en.b6d821c3.png";